export default "__VITE_ASSET__ChHdV$NT__"